/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEligibleOffers_decisions_Decision = { readonly __typename: 'Decision', readonly id: string, readonly approvedAmountInCents: number, readonly offerType: _Types.UnderwritingOffer };

export type GetEligibleOffers_Query = { readonly __typename: 'Query', readonly decisions: ReadonlyArray<GetEligibleOffers_decisions_Decision | null> | null };


export type GetEligibleOffersVariables = _Types.Exact<{
  companyId: _Types.Scalars['String']['input'];
}>;


export type GetEligibleOffers = GetEligibleOffers_Query;


export const GetEligibleOffersDocument = gql`
    query GetEligibleOffers($companyId: String!) {
  decisions(companyId: $companyId) {
    id
    approvedAmountInCents
    offerType
  }
}
    `;

/**
 * __useGetEligibleOffers__
 *
 * To run a query within a React component, call `useGetEligibleOffers` and pass it any options that fit your needs.
 * When your component renders, `useGetEligibleOffers` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEligibleOffers({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetEligibleOffers(baseOptions: Apollo.QueryHookOptions<GetEligibleOffers, GetEligibleOffersVariables> & ({ variables: GetEligibleOffersVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEligibleOffers, GetEligibleOffersVariables>(GetEligibleOffersDocument, options);
      }
export function useGetEligibleOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEligibleOffers, GetEligibleOffersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEligibleOffers, GetEligibleOffersVariables>(GetEligibleOffersDocument, options);
        }
export function useGetEligibleOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEligibleOffers, GetEligibleOffersVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEligibleOffers, GetEligibleOffersVariables>(GetEligibleOffersDocument, options);
        }
export type GetEligibleOffersHookResult = ReturnType<typeof useGetEligibleOffers>;
export type GetEligibleOffersLazyQueryHookResult = ReturnType<typeof useGetEligibleOffersLazyQuery>;
export type GetEligibleOffersSuspenseQueryHookResult = ReturnType<typeof useGetEligibleOffersSuspenseQuery>;
export type GetEligibleOffersQueryResult = Apollo.QueryResult<GetEligibleOffers, GetEligibleOffersVariables>;